<template>
  <v-menu
      ref="menu1"
      v-model="menuDataPicker"
      :readonly="readonly"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="date"
      transition="scale-transition"
      offset-y
      min-width="290px">
    <template v-slot:activator="{ on }">
      <v-text-field
          v-model="formattedData"
          :error="hasErrors"
          :label="label"
          :dense="dense"
          prepend-icon="event"
          readonly
          :error-messages="errorMessages"
          :append-icon="!readonly && value && !menuDataPicker
            ? 'clear'
            : null"
          v-on="on"
          @click:append="clear">
        <template v-if="required" v-slot:prepend-inner>
          <v-icon
              small
              left
              :color="requiredColor">
            *
          </v-icon>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
        v-model="date"
        :allowed-dates="checkDate"
        :readonly="readonly"
        no-title
        scrollable
        :locale="controlLocale"
        :first-day-of-week="1"
        :min="minDate"
        :max="maxDate">
      <v-spacer />
      <v-btn
          id="cancelDateBtn"
          text
          color="primary"
          @click.stop="menuDataPicker = false">
        {{ $t('Отмена') }}
      </v-btn>
      <v-btn
          id="selectDateBtn"
          text
          color="primary"
          @click.stop="saveDate">
        {{ $t('Выбрать') }}
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
  export default {
    props: {
      value: {
        required: true
      },
      readonly: {
        type: Boolean,
        default: false
      },
      label: String,
      errorMessages: Array,
      minSelectedDate: {
        type: String,
        default: '1991-01-01'
      },
      maxSelectedDate: {
        type: String
      },
      dayOffDates: Array,
      required: {
        type: Boolean,
        default: false
      },
      dense: {
        type: Boolean,
        default: false
      },
      requiredColor: {
        type: String,
        default: 'requiredfield'
      }
    },
    data () {
      return {
        menuDataPicker: false,
        date: null
      }
    },
    computed: {
      formattedData () {
        return this.date
          ? this.$moment(this.date).format('DD.MM.YYYY')
          : null
      },
      hasErrors () {
        return this.errorMessages && this.errorMessages.length > 0
      },
      minDate () {
        return this.$moment(this.minSelectedDate).format('YYYY-MM-DD')
      },
      maxDate () {
        return this.maxSelectedDate
          ? this.$moment(this.maxSelectedDate).format('YYYY-MM-DD')
          : this.$moment(this.$moment().add(10, 'years')).format('YYYY-MM-DD')
      }
    },
    watch: {
      value: {
        immediate: true,
        handler (newValue) {
          if (newValue) {
            this.date = newValue
          }
        }
      }
    },
    methods: {
      checkDate: function (val) {
        return (
          !this.dayOffDates ||
          !this.dayOffDates.length ||
          !this.dayOffDates.includes(val)
        )
      },
      saveDate: function () {
        this.$refs.menu1.save(this.date)
        this.updateValue()
      },
      updateValue: function () {
        if (!this.date) {
          return
        }
        // let newDateTime = this.$moment(this.date, 'YYYY-MM-DD').format('YYYY-MM-DD')
        // изменение поля (привязанного через дерективу v-model) в родительском компоненте
        this.$emit('input', this.date)
        // информируем родительский компонент, что дата поменялась, для запуска самописной обработки
        this.$emit('change')
      },
      clear: function () {
        this.date = null
        this.$emit('input', null)
      }
    }
  }
</script>
